import { Components, Theme, tabClasses } from '@mui/material';

/**
 * Component overrides (i.e. global styles, default props) applied to the MUI
 * Tab to make it match the design system.
 *
 * See: https://mui.com/material-ui/api/tab/#css
 */
export const MuiTab: Components<Theme>['MuiTab'] = {
  defaultProps: {
    iconPosition: 'start',
  },
  styleOverrides: {
    root: ({ ownerState, theme }) => ({
      minHeight: 'min-content',
      padding: theme.spacing(1.5, 2),
      ...(theme.featureFlags.panwRebrandStubYear && {
        color: theme.palette.text.placeholder,
        [`&.${tabClasses.selected}`]: {
          color: theme.palette.text.selected,
        },
        [`&.${tabClasses.selected} .${tabClasses.iconWrapper}`]: {
          color: theme.palette.text.selected,
        },
        [`&.${tabClasses.root}:hover:not(.${tabClasses.selected})`]: {
          color: theme.palette.text.primary,
        },
      }),

      // the `iconWrapper` top-level rule name doesn't work
      [`& .${tabClasses.iconWrapper}`]: {
        height: '16px',
        width: '16px',
        margin: ownerState.iconPosition === 'start' ? theme.spacing(0, 1.75, 0, 0) : theme.spacing(0, 0, 0, 1.75),
      },
    }),
  },
};

/**
 * Component overrides (i.e. global styles, default props) applied to the MUI
 * Tabs to make it match the design system.
 *
 * See: https://mui.com/material-ui/api/tabs/#css
 */
export const MuiTabs: Components<Theme>['MuiTabs'] = {
  styleOverrides: {
    root: { minHeight: 'min-content' },
    indicator: ({ theme }) =>
      theme.featureFlags.panwRebrandStubYear ? { backgroundColor: theme.palette.text.selected } : {},
  },
};
